import React, { useState } from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";

import { Card, Button, SelectInput, InputLabel } from "../../../../components";
import { formatDateForSearch } from "../dashboad.services";
import * as dashboardService from "../../../../services/api/hr/dashboard.service";
import { downloadBlob } from "../../../../services/files.utils";
import { reportTypeDropdownOptions } from "../../../SuperAdminPages/Dashboard/reportTypeDropdownOptions";
import { useTranslation } from "react-i18next";

const UsageReportGeneratorStyles = styled.div`
  margin: 0 20px 20px 0;
  order: 7;
  width: 400px;
`;

const UsageReport = () => {
  const { t } = useTranslation();
  const [date, setDate] = useState(new Date());
  const [searchDateString, setSearchDateString] = useState(
    formatDateForSearch(new Date())
  );
  const [reportType, setReportType] = useState(undefined);

  const handleDateChange = chosenDate => {
    setDate(chosenDate);
    setSearchDateString(formatDateForSearch(chosenDate));
  };

  const getStatistics = async () => {
    const response = await dashboardService.getStatistics(
      searchDateString,
      reportType
    );

    if (response.hasError) {
      return toast.error(
        response.errorMessage
          ? t(response.errorMessage)
          : t("failed_to_get_statistics")
      );
    }

    downloadBlob(response.data, "export.csv", "text/csv;charset=utf-8;");
  };

  return (
    <UsageReportGeneratorStyles>
      <Card>
        <div className="titleContainer">
          <DatePicker
            className="datePickerInput"
            id="usageReportGeneratorId"
            selected={date}
            dateFormat="MM/yyyy"
            showMonthYearPicker
            onChange={chosenDate => handleDateChange(chosenDate)}
            value={date}
            maxDate={new Date()}
          />
          <h3 className="title">{t("gen_usr_rep")}</h3>
        </div>
        <div style={{ marginTop: 10, marginBottom: 10 }}>
          <InputLabel label={t("select_report_type")} margin="0 0 5px 0" />
          <SelectInput
            name="reportTypes"
            options={reportTypeDropdownOptions(t)}
            selectedValues={reportTypeDropdownOptions(t)}
            value={reportType}
            handleChange={option => setReportType(option.id)}
            customId="reportTypeId"
            shouldHaveHight={false}
            shouldHaveFullWidth
            customHeight="27px"
          />
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            margin="0"
            width="200px"
            disabled={!searchDateString || !reportType}
            onClick={() => getStatistics()}
          >
            {t("download")}
          </Button>
        </div>
      </Card>
    </UsageReportGeneratorStyles>
  );
};

export default UsageReport;
